
export const types = {
    authCheckingFinish: '[auth] Finish checking login state',
    authStartLogin: '[auth] Start login',
    authLogin: '[auth] Login',
    authStartRegister: '[auth] Start Register',
    authStartTokenRenew: '[auth] Start token renew',
    authLogout: '[auth] Logout',
    authUpdatePhoto: '[auth] update photo',

    pptoCargarLista: '[ppto] cargar lista',
    budgetsLoadTotalesLista: '[ppto] load totales lista',

    pptoSetList: '[ppto] Set list',
    budgetsLoadDetail: '[budgets] load detail',
    budgetsLoadItems: '[budgets] load items',
    budgetsAddItem: '[budgets] add item',
    budgetsDuplicateItem: '[budgets] duplicate item',
    budgetsRemoveItem: '[budgets] remove item',
    budgetsUpdateTotales: '[budgets] update totales',
    budgetsSetNewIds: '[budgets]set new ids',
    budgetsUpdateDatosInicialesNotSave: '[budgets] update data not save',
    budgetsUpdateCondicionesNotSave: '[budgets] update condiciones not save',
    budgetsUpdateMontosFinalNotSave: '[budgets] update montos finales not save',
    budgetsUpdateColumnName: '[budgets] update nombre columna',
    budgetsUpdateInfoFactNotSave: '[budgets] update info fact not save',
    budgetsUpdateProjections: '[budgets] update projections',
    budgetsUpdateNewFolio: '[budgets] set new folio',

    budgetsSetRules: '[budgets] set rules',
    budgetsUpdateValidationStatus: '[budgets] update validation status',

    budgetsSetIsTemplate: '[budgets] set is template',
    budgetsSetFiltersList: '[budgets] set filters list',
    dashboardSetFiltersList: '[dashboard] set filters list',

    projectLoadDetail: '[project] load detail',
    projectLoadList: '[project] load list',
    projectSetNewId: '[project] set new id',
    projectSavedCloud: '[project] saved cloud',

    hitoAdd: '[hito] hito add',
    setAllHitos: '[hito] set all hitos',
    taskAdd: '[task] new add',

}